import { c as REQUEST_TIMEOUT_MILLISECONDS, i as isBunRuntime, l as FetchBase, s as FetchTimeoutError, t as WebSocketFactory, u as LsFetch } from "./src-sUhLoNe4.mjs";
import { Injectable } from "@gitlab/needle";
import https from "https";
import http from "http";
import fs from "fs";
import { getProxySettings } from "get-proxy-settings";
import { ProxyAgent } from "proxy-agent";
import { getProxyForUrl } from "proxy-from-env";
import { isEqual } from "lodash-es";
import { Logger } from "@gitlab-org/logging";
import { isAbortError } from "@gitlab-org/resiliency";
import { Agent, EnvHttpProxyAgent } from "undici";
import IsomorphicWebSocket from "isomorphic-ws";
import PureWebSocket from "pure-ws";
//#region src/node/is_keep_alive_affected_node_version.ts
/**
* Returns true if the current Node.js version is affected by the keep-alive
* regression introduced in Node 24.17.0 and fixed in Node 24.18.0.
*
* VS Code 1.128.0 ships Electron 42.5.0 with Node 24.17.0, which introduced a
* regression in `http.Agent` keep-alive socket handling that breaks `node-fetch`
* gzip/chunked responses, causing authentication failures.
*
* See https://github.com/nodejs/node/issues/63989
* See https://github.com/node-fetch/node-fetch/issues/1767
*/
const isKeepAliveAffectedNodeVersion = () => {
	const [major, minor] = process.versions.node.split(".").map(Number);
	return major === 24 && minor === 17;
};
//#endregion
//#region src/node/fetch.ts
let _initClass$1;
function _applyDecs$1(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$1(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$1(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$1(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$1(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$1(t) {
	var i = _toPrimitive$1(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$1(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$1(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const httpAgent = new http.Agent({ keepAlive: !isKeepAliveAffectedNodeVersion() });
function isCloseable(dispatcher) {
	return typeof dispatcher?.close === "function";
}
async function closeDispatcher(dispatcher) {
	if (isCloseable(dispatcher)) await dispatcher.close();
}
let _Fetch;
(class extends FetchBase {
	static {
		[_Fetch, _initClass$1] = _applyDecs$1(this, [Injectable(LsFetch, [Logger])], [], 0, void 0, FetchBase).c;
	}
	#dispatcher;
	#directDispatcher;
	#proxy;
	#userProxy;
	#initialized = false;
	#httpsAgent;
	#agentOptions;
	#logger;
	constructor(logger, userProxy) {
		super();
		this.#logger = logger;
		this.#agentOptions = { rejectUnauthorized: true };
		this.#userProxy = userProxy;
		this.#httpsAgent = this.#createHttpsAgent();
	}
	async initialize() {
		try {
			const proxy = await getProxySettings();
			if (proxy?.http) {
				process.env.http_proxy = `${proxy.http.protocol}://${proxy.http.host}:${proxy.http.port}`;
				this.#logger.info(`fetch: Detected http proxy through settings: ${process.env.http_proxy}`);
				if (proxy.http?.credentials && proxy.http.credentials?.username && proxy.http.credentials?.password) {
					this.#logger.info(`fetch: Added credentials to http_proxy for username: ${proxy.http.credentials.username}`);
					process.env.http_proxy = `${proxy.http.protocol}://${proxy.http.credentials.username}:${proxy.http.credentials.password}@${proxy.http.host}:${proxy.http.port}`;
				}
			}
			if (proxy?.https) {
				process.env.https_proxy = `${proxy.https.protocol}://${proxy.https.host}:${proxy.https.port}`;
				this.#logger.info(`fetch: Detected https proxy through settings: ${process.env.https_proxy}`);
				if (proxy.https?.credentials && proxy.https.credentials?.username && proxy.https.credentials?.password) {
					this.#logger.info(`fetch: Added credentials to HTTPS_PROXY for username: ${proxy.https.credentials.username}`);
					process.env.https_proxy = `${proxy.https.protocol}://${proxy.https.credentials.username}:${proxy.https.credentials.password}@${proxy.https.host}:${proxy.https.port}`;
				}
			}
			/**
			* Set up WebSocketProxy env vars
			* Used by proxy-from-env via the proxy-agent dependency
			* Set both proxies as we don't know until later whether the endpoint is ws:// or wss://
			*/
			if (process.env.wss_proxy || process.env.ws_proxy) this.#logger.info(`fetch: Detected existing ${process.env.wss_proxy ? "wss_proxy" : "ws_proxy"} setting`);
			else if (proxy?.https) {
				this.#logger.info("fetch: Setting WebSocket proxy based on https_proxy setting");
				process.env.ws_proxy = process.env.https_proxy;
				process.env.wss_proxy = process.env.https_proxy;
			} else if (proxy?.http) {
				this.#logger.info("fetch: Setting WebSocket proxy based on http_proxy setting");
				process.env.ws_proxy = process.env.http_proxy;
				process.env.wss_proxy = process.env.http_proxy;
			}
			if (!proxy?.http && !proxy?.https && !process.env.ws_proxy && !process.env.wss_proxy) this.#logger.info(`fetch: Detected no proxy settings`);
		} catch (err) {
			this.#logger.warn("Unable to load proxy settings", err);
		}
		if (this.#userProxy) {
			this.#logger.debug(`fetch: Detected user proxy ${this.#userProxy.replace(/\/\/([^:]+):(.+)@/, "//$1:***@")}`);
			process.env.http_proxy = this.#userProxy;
			process.env.https_proxy = this.#userProxy;
		}
		this.#directDispatcher = this.#createDirectDispatcher();
		if (process.env.http_proxy || process.env.https_proxy || process.env.ws_proxy || process.env.wss_proxy) {
			const noProxy = process.env.NO_PROXY ?? process.env.no_proxy ?? "";
			if (noProxy?.length) this.#logger.info(`fetch: Skipping proxy for hosts in no_proxy: ${noProxy}`);
			this.#proxy = this.#createProxyAgent();
			this.#dispatcher = new EnvHttpProxyAgent(this.#getDispatcherOptions());
		} else this.#dispatcher = this.#directDispatcher;
		this.#initialized = true;
	}
	async destroy() {
		this.#proxy?.destroy();
		if (this.#dispatcher && this.#dispatcher !== this.#directDispatcher) await closeDispatcher(this.#dispatcher);
		await closeDispatcher(this.#directDispatcher);
	}
	async fetchBase(input, init, options) {
		if (!this.#initialized) throw new Error("LsFetch not initialized. Make sure LsFetch.initialize() was called.");
		return this.#fetchLogged(input, {
			...init,
			agent: this.#getAgent(input, options),
			dispatcher: this.#getDispatcher(options)
		}, super.fetchBase);
	}
	async fetch(input, init, options) {
		if (!this.#initialized) throw new Error("LsFetch not initialized. Make sure LsFetch.initialize() was called.");
		const controller = new AbortController();
		const timeoutAbortSignal = AbortSignal.timeout(REQUEST_TIMEOUT_MILLISECONDS);
		[init?.signal, timeoutAbortSignal].forEach((signal) => {
			signal?.addEventListener("abort", () => controller.abort(signal.reason), { once: true });
		});
		try {
			return await this.#fetchLogged(input, {
				...init,
				signal: controller.signal,
				agent: this.#getAgent(input, options),
				dispatcher: this.#getDispatcher(options)
			}, super.fetch);
		} catch (e) {
			if (isAbortError(e)) {
				const { reason } = controller.signal;
				if (reason instanceof Error && reason.name === "TimeoutError") throw new FetchTimeoutError(input);
			}
			throw e;
		}
	}
	getWebSocketOptions(input, options) {
		const agent = this.#getAgent(input, options);
		const isProxy = agent === this.#proxy;
		const result = {
			agent,
			tls: { ...this.#agentOptions }
		};
		if (isProxy) {
			const resolved = getProxyForUrl(this.#toWebSocketUrl(this.#extractURL(input)));
			if (resolved) result.proxyUrl = resolved;
		}
		return result;
	}
	updateAgentOptions({ ignoreCertificateErrors, ca, cert, certKey }) {
		let fileOptions = {};
		try {
			fileOptions = {
				...ca ? { ca: fs.readFileSync(ca) } : {},
				...cert ? { cert: fs.readFileSync(cert) } : {},
				...certKey ? { key: fs.readFileSync(certKey) } : {}
			};
		} catch (err) {
			this.#logger.error("Error reading https agent options from file", err);
		}
		const newOptions = {
			rejectUnauthorized: !ignoreCertificateErrors,
			...fileOptions
		};
		if (isEqual(newOptions, this.#agentOptions)) return;
		this.#agentOptions = newOptions;
		this.#httpsAgent = this.#createHttpsAgent();
		const oldDirectDispatcher = this.#directDispatcher;
		this.#directDispatcher = this.#createDirectDispatcher();
		closeDispatcher(oldDirectDispatcher).catch(() => {});
		if (this.#proxy) {
			this.#proxy = this.#createProxyAgent();
			this.#dispatcher = new EnvHttpProxyAgent(this.#getDispatcherOptions());
		} else this.#dispatcher = this.#directDispatcher;
	}
	/**
	* Note: we yield chunks of the stream as strings,
	* as the caller is responsible for aggregating them
	*/
	async *streamResponse(response, cancellationToken) {
		const logger = this.#logger;
		if (!response.body) return;
		const decoder = new TextDecoder();
		async function* readStream(stream) {
			for await (const chunk of stream) {
				if (cancellationToken.isCancellationRequested) {
					if ("destroy" in stream) {
						logger.debug("Cancelling stream");
						stream.destroy();
					}
					return;
				}
				yield decoder.decode(chunk);
			}
		}
		yield* readStream(response.body);
	}
	#createHttpsAgent() {
		const agentOptions = {
			...this.#agentOptions,
			keepAlive: !isKeepAliveAffectedNodeVersion()
		};
		this.#logger.debug(`fetch: https agent with options initialized ${JSON.stringify(this.#sanitizeAgentOptions(agentOptions))}.`);
		return new https.Agent(agentOptions);
	}
	#createProxyAgent() {
		this.#logger.debug(`fetch: proxy agent with options initialized ${JSON.stringify(this.#sanitizeAgentOptions(this.#agentOptions))}.`);
		return new ProxyAgent(this.#agentOptions);
	}
	#createDirectDispatcher() {
		return new Agent(this.#getDispatcherOptions());
	}
	async #fetchLogged(input, init, fetchImpl) {
		const start = Date.now();
		const url = this.#extractURL(input);
		if (init.agent === httpAgent) this.#logger.debug(`fetch: request for ${url} made with http agent.`);
		else {
			const type = init.agent === this.#proxy ? "proxy" : "https";
			this.#logger.debug(`fetch: request for ${url} made with ${type} agent.`);
		}
		try {
			const resp = await fetchImpl(input, init);
			const duration = Date.now() - start;
			this.#logger.debug(`fetch: request to ${url} returned HTTP ${resp.status} after ${duration} ms`);
			return resp;
		} catch (e) {
			const duration = Date.now() - start;
			this.#logger.debug(`fetch: request to ${url} threw an exception after ${duration} ms`);
			throw e;
		}
	}
	#getAgent(input, options) {
		if (this.#proxy && options?.proxyResolutionMode !== "direct") return this.#proxy;
		if (input.toString().startsWith("https://")) return this.#httpsAgent;
		return httpAgent;
	}
	#getDispatcher(options) {
		if (options?.proxyResolutionMode === "direct") return this.#directDispatcher;
		return this.#dispatcher;
	}
	#getDispatcherOptions = () => ({
		keepAliveTimeout: 1e3,
		requestTls: this.#agentOptions
	});
	#toWebSocketUrl(url) {
		if (url.startsWith("https://")) return `wss://${url.slice(8)}`;
		if (url.startsWith("http://")) return `ws://${url.slice(7)}`;
		return url;
	}
	#extractURL(input) {
		if (input instanceof URL) return input.toString();
		if (typeof input === "string") return input;
		return input.url;
	}
	#sanitizeAgentOptions(agentOptions) {
		const { ca, cert, key, ...options } = agentOptions;
		return {
			...options,
			...ca ? { ca: "<hidden>" } : {},
			...cert ? { cert: "<hidden>" } : {},
			...key ? { key: "<hidden>" } : {}
		};
	}
	static {
		_initClass$1();
	}
});
//#endregion
//#region src/node/websocket_factory.ts
let _initClass;
function _applyDecs(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
/**
* Under Bun the implementation must be the real pure-JS `ws` package: Bun
* substitutes its own shim for the literal `ws` specifier (even inside
* `bun build --compile` binaries), and that shim drops the `ca` / `cert` /
* `key` / `agent` options — the exact regression behind issue #2527
* (re-verified broken on 1.4.0 stable). The `pure-ws` npm alias resolves
* to the genuine package, which works on Bun >= 1.4 thanks to the
* `http(s).request` 'upgrade' fix (oven-sh/bun#5951).
*
* On Node `isomorphic-ws` keeps the existing behaviour: the same `ws`
* package. This module must stay out of the browser graph — it is exported
* only from `@gitlab-org/fetch/node`.
*/
let _NodeWebSocketFactory;
(class {
	static {
		[_NodeWebSocketFactory, _initClass] = _applyDecs(this, [Injectable(WebSocketFactory, [])], []).c;
	}
	implementation = isBunRuntime() ? PureWebSocket : IsomorphicWebSocket;
	static {
		_initClass();
	}
});
//#endregion
export { _Fetch as Fetch, _NodeWebSocketFactory as NodeWebSocketFactory };

//# sourceMappingURL=node.mjs.map